<template lang='pug'>
v-app
  //- | {{categories}}
  div.mt-3
    v-row
      v-col(cols='10')
        v-text-field(v-model='name' label='カテゴリー名' hide-details)
      v-col(cols='2')
        v-btn.mt-2(block prepend-icon='mdi-plus' @click='createCategory' :disabled='!name') 新規作成
    span.mb-2(v-if='!dialog && errorMessage' style='color: red') {{ errorMessage }}

  Draggable.mt-2(v-model='categories' treeLine @change='updateRelationships')
    template(#default='{ node, stat }')
      .py-2
        v-card.w-100(color='#edebfa' variant='elevated')
          v-card-text.py-0.ps-1.pe-0.d-flex.flex-column
            .d-flex.justify-space-between.w-100
              .d-flex.align-center
                OpenIcon(v-if='stat.children.length' :open='stat.open' class='mtl-mr mx-1' @click.native='stat.open = !stat.open')
                v-icon.me-1(icon='mdi-drag')
                | {{ node.name }}
              .d-flex
                v-btn(variant='text' size='small' color='secondary' icon='mdi-square-edit-outline' @click='showDialog(node.id)')
                v-divider.my-2(vertical color='primary')
                v-btn(variant='text' size='small' color='secondary' icon='mdi-information-outline' @click='stat.expand = !stat.expand')
                .d-flex.align-center
                  v-chip.me-2(density='compact' prepend-icon='mdi-file')
                    | {{ node.asset_files.length }}
            .d-flex
              v-expand-transition
                v-row(v-if='stat.expand')
                  v-col.p-3(cols='12')
                    v-chip.mb-2(v-for='(asset_file, index) in node.asset_files' :key='index' size='x-large' pill class='me-2')
                      v-avatar(v-if='asset_file.thumbnail_url' start)
                        v-img(:src='asset_file.thumbnail_url' size='40' class='mx-1')
                      | {{ asset_file.name }}

  v-dialog(v-model='dialog', max-width=800 scrollable persistent :attach='true')
    v-card(v-if='selectedCategoryData' title='組織編集')
      v-divider
      v-card-text
        h6.mb-3 組織名
        v-text-field(v-model='selectedCategoryData.name' label='カテゴリー名' hide-details)
        span(v-if='dialog && errorMessage' style='color: red') {{ errorMessage }}
      template(v-slot:actions)
        v-btn(color='red' prepend-icon='mdi-trash-can' text='削除', @click='deleteCategory')
        v-btn.ms-auto(prepend-icon='mdi-check' text='OK', @click='closeDialog')


</template>

<script setup>
import axios from 'axios'
import { ref } from 'vue'
import { BaseTree, Draggable, OpenIcon } from '@he-tree/vue'
import '@he-tree/vue/style/default.css'

import showToast from '../shared/show_toast'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
}

const props = defineProps({
  categoryBaseUrl: {
    type: String,
    required: true
  },
  categories: {
    type: String,
    required: true
  },
})
const categoryBaseUrl = props.categoryBaseUrl
const categories = ref(JSON.parse(props.categories))
const selectedCategoryData = ref(null)
const description = ref(null)
const dialog = ref(false)
const errorMessage = ref(null)
const name = ref(null)

const closeDialog = async () => {
  try {
    const res = await axios.patch(`${categoryBaseUrl}/${selectedCategoryData.value.id}.json`, {
      category: { name: selectedCategoryData.value.name },
    })
    categories.value = res.data.categories
    selectedCategoryData.value = null
    errorMessage.value = null
    dialog.value = false
    showToast(res.data.message)
  } catch (error) {
    errorMessage.value = error.response?.data?.join(',')
  }
}

const createCategory = async () => {
  try {
    const res = await axios.post(categoryBaseUrl, {
      category: { name: name.value }
    })
    categories.value = res.data.data
    errorMessage.value = null
    showToast(res.data.message)
  } catch (error) {
    errorMessage.value = error.response?.data?.join(',')
  }
}

const deleteCategory = async () => {
  const result = confirm('削除しますか？　子カテゴリーがある場合、子カテゴリーは自動的に更に上のカテゴリーの子カテゴリーになるか、該当カテゴリーがない場合は空になります。')
  if (result) {
    try {
      const res = await axios.delete(`${categoryBaseUrl}/${selectedCategoryData.value.id}.json`)
      categories.value = res.data.categories
      selectedCategoryData.value = null
      errorMessage.value = null
      dialog.value = false
      showToast(res.data.message)
    } catch (error) {
      errorMessage.value = error.response?.data?.join(',')
    }
  }
}

const getParams = (nodes, parentId = null, result = []) => {
  nodes.forEach((node, index) => {
    result.push({ id: node.id, parent_id: parentId, order: index })
    if (node.children?.length > 0) {
      getParams(node.children, node.id, result)
    }
  })
  return result
}

const showDialog = async (id) => {
  errorMessage.value = null
  try {
    const res = await axios.get(`${categoryBaseUrl}/${id}.json`)
    selectedCategoryData.value = res.data
    dialog.value = true
  } catch (error) {
    errorMessage.value = error.response?.data?.join(',')
  }
}

const updateRelationships = async () => {
  const newRelationships = getParams(categories.value)
  try {
    const res = await axios.patch(`${categoryBaseUrl}/update_relationships`, {
      new_relationships: newRelationships
    })
    categories.value = res.data
    errorMessage.value = null
  } catch (error) {
    errorMessage.value = error.response?.data?.join(',')
  }
}
</script>
